// extracted by mini-css-extract-plugin
module.exports = {"bellButton":"style_bellButton__2xpDW","notifications":"style_notifications__2_TXp","emptyPlaceholder":"style_emptyPlaceholder__1wGhc","unread":"style_unread__2XL8b"};